import React, { useContext } from 'react';
import { RadioGroup } from '@headlessui/react';
import classNames from 'classnames';
import { locationTypes } from '../../utils/map';
import { FilterContext } from './locationFinder';
import { useTranslation } from 'react-i18next';

export default function LocationTypeFilter() {
  const { activeTypeId, setActiveTypeId } = useContext(FilterContext);
  const { t } = useTranslation();
  return (
    <div className="tw-p-4 tw-text-base">
      <RadioGroup value={activeTypeId} onChange={setActiveTypeId}>
        <RadioGroup.Label className="tw-sr-only">
          Location Type
        </RadioGroup.Label>

        <div className="tw-grid tw-grid-cols-3 ">
          {locationTypes.map((type) => (
            <RadioGroup.Option value={type.id} key={type.id}>
              {({ checked }) => (
                <span
                  className={classNames(
                    checked && 'tw-bg-yellow tw-text-blue tw-font-bold',
                    'tw-p-4 tw-py-3 tw-rounded-md tw-block tw-text-center tw-font-mono '
                  )}>
                  {t(type.value.toUpperCase())}
                </span>
              )}
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
}
